/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'location-icon': {
    width: 18,
    height: 23,
    viewBox: '0 0 18 23',
    data: '<path pid="0" d="M.551 8.148C.551 3.641 4.324 0 8.966 0c4.642 0 8.415 3.64 8.415 8.148 0 1.482-.806 3.55-2.235 6.128-.42.759-.89 1.55-1.398 2.363a77.776 77.776 0 01-3.547 5.178c-.648.88-1.834.87-2.47 0a75.98 75.98 0 01-1.112-1.53 77.649 77.649 0 01-2.437-3.652 52.489 52.489 0 01-1.4-2.365C1.357 11.696.553 9.63.553 8.148zm8.664 12.315a76.203 76.203 0 003.176-4.672c.495-.791.95-1.558 1.356-2.291 1.302-2.35 2.034-4.227 2.034-5.352 0-3.61-3.044-6.548-6.815-6.548-3.77 0-6.815 2.938-6.815 6.548 0 1.124.731 3 2.031 5.347.406.733.861 1.5 1.356 2.292a76.076 76.076 0 003.428 5.01c.058-.076.141-.188.249-.334zm-.249-8.72c-1.94 0-3.518-1.558-3.518-3.485 0-1.927 1.577-3.485 3.518-3.485 1.941 0 3.519 1.558 3.519 3.485 0 1.927-1.578 3.485-3.519 3.485zm0-1.6c1.062 0 1.919-.846 1.919-1.885 0-1.039-.857-1.885-1.919-1.885s-1.918.846-1.918 1.885c0 1.039.856 1.885 1.918 1.885z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
